import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Stepper, Step, StepLabel, StepConnector } from '@material-ui/core';
import styled from 'styled-components';
import CustomTypography from 'components/atoms/CustomTypography';
import { colors } from 'theme/Variables';
import BoxWrapper from 'components/atoms/BoxWrapper';

const StyledStepper = styled(Stepper)`
    background-color: transparent !important;
`;

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 1.5,
        left: 'calc(-50% + 3px)',
        right: 'calc(50% + 3px)',
    },
    active: {
        '& $line': {
            backgroundColor: '#FF93BC',
        },
    },
    completed: {
        '& $line': {
            backgroundColor: '#FF93BC',
        },
    },
    line: {
        height: 2,
        border: 0,
        backgroundColor: '#ccc',
        borderRadius: 100,
    },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        width: 6,
        height: 6,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundColor: '#FF93BC',
    },
    completed: {
        backgroundColor: '#FF93BC',
    },
});

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        />
    );
}

const CustomizedStepper = ({ steps, activeStep }) => {
    const maximumSteps = Object.keys(steps).length;

    return (
        <>
            <StyledStepper
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorlibConnector />}
            >
                {Object.keys(steps).map((label) => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={ColorlibStepIcon} />
                    </Step>
                ))}
            </StyledStepper>
            <BoxWrapper>
                <CustomTypography align="center" customcolor={colors.primary['200']} fontSize="1.2">
                    step {activeStep + 1} of {maximumSteps}
                </CustomTypography>
            </BoxWrapper>
        </>
    );
};

export default CustomizedStepper;
